import {useCallback, useRef} from 'react';
import {Handler} from '../typeHelpers';

/**
 * Returns a setTimeout-like function and its cleanup helper that clears the
 * previous timeout when re-invoked or when the component unmounts.
 */
export function useTimeout() {
  const handleRef = useRef<number>();
  const setHookTimeout = useCallback((handler: Handler, timeout?: number) => {
    clearTimeout(handleRef.current);
    handleRef.current = setTimeout(handler, timeout);
  }, []);

  const clearHookTimeout = () => clearTimeout(handleRef.current);

  const timeoutFunctions: [typeof setHookTimeout, Handler] = [setHookTimeout, clearHookTimeout];

  return timeoutFunctions;
}
